import {
  AE, AD, AM, AR, AT, AU, AZ, BA, BE, BG, BH, BR, BY, CA, CH, CL, CN, CO,
  CZ, DE, DK, DZ, EE, ES, FI, FR, GB, GE, GR, HK, HR, HU, ID, IE, IL, IN,
  IR, IS, IT, JM, JP, KE, KG, KP, KR, KZ, LB, LI, LT, LU, LV, MA, MD, MK,
  MN, MO, MX, MY, NL, NO, NP, NZ, OM, PH, PL, PR, PT, QA, RO, RS, RU, SE,
  SG, SI, SK, TH, TM, TN, TR, TW, UA, US, UZ, ZA,
} from "country-flag-icons/react/3x2";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

export const phoneUtil = PhoneNumberUtil.getInstance();

// United States first so it remains the default/fallback.
export const COUNTRY_OPTIONS = [
  { id: "US", label: "United States", FlagIcon: US, dialCode: "+1" },
  { id: "AD", label: "Andorra", FlagIcon: AD, dialCode: "+376" },
  { id: "AE", label: "United Arab Emirates", FlagIcon: AE, dialCode: "+971" },
  { id: "AM", label: "Armenia", FlagIcon: AM, dialCode: "+374" },
  { id: "AR", label: "Argentina", FlagIcon: AR, dialCode: "+54" },
  { id: "AT", label: "Austria", FlagIcon: AT, dialCode: "+43" },
  { id: "AU", label: "Australia", FlagIcon: AU, dialCode: "+61" },
  { id: "AZ", label: "Azerbaijan", FlagIcon: AZ, dialCode: "+994" },
  { id: "BA", label: "Bosnia and Herzegovina", FlagIcon: BA, dialCode: "+387" },
  { id: "BE", label: "Belgium", FlagIcon: BE, dialCode: "+32" },
  { id: "BG", label: "Bulgaria", FlagIcon: BG, dialCode: "+359" },
  { id: "BH", label: "Bahrain", FlagIcon: BH, dialCode: "+973" },
  { id: "BR", label: "Brazil", FlagIcon: BR, dialCode: "+55" },
  { id: "BY", label: "Belarus", FlagIcon: BY, dialCode: "+375" },
  { id: "CA", label: "Canada", FlagIcon: CA, dialCode: "+1" },
  { id: "CH", label: "Switzerland", FlagIcon: CH, dialCode: "+41" },
  { id: "CL", label: "Chile", FlagIcon: CL, dialCode: "+56" },
  { id: "CN", label: "China", FlagIcon: CN, dialCode: "+86" },
  { id: "CO", label: "Colombia", FlagIcon: CO, dialCode: "+57" },
  { id: "CZ", label: "Czechia", FlagIcon: CZ, dialCode: "+420" },
  { id: "DE", label: "Germany", FlagIcon: DE, dialCode: "+49" },
  { id: "DK", label: "Denmark", FlagIcon: DK, dialCode: "+45" },
  { id: "DZ", label: "Algeria", FlagIcon: DZ, dialCode: "+213" },
  { id: "EE", label: "Estonia", FlagIcon: EE, dialCode: "+372" },
  { id: "ES", label: "Spain", FlagIcon: ES, dialCode: "+34" },
  { id: "FI", label: "Finland", FlagIcon: FI, dialCode: "+358" },
  { id: "FR", label: "France", FlagIcon: FR, dialCode: "+33" },
  { id: "GB", label: "Great Britain", FlagIcon: GB, dialCode: "+44" },
  { id: "GE", label: "Georgia", FlagIcon: GE, dialCode: "+995" },
  { id: "GR", label: "Greece", FlagIcon: GR, dialCode: "+30" },
  { id: "HK", label: "Hong Kong", FlagIcon: HK, dialCode: "+852" },
  { id: "HR", label: "Croatia", FlagIcon: HR, dialCode: "+385" },
  { id: "HU", label: "Hungary", FlagIcon: HU, dialCode: "+36" },
  { id: "ID", label: "Indonesia", FlagIcon: ID, dialCode: "+62" },
  { id: "IE", label: "Ireland", FlagIcon: IE, dialCode: "+353" },
  { id: "IL", label: "Israel", FlagIcon: IL, dialCode: "+972" },
  { id: "IN", label: "India", FlagIcon: IN, dialCode: "+91" },
  { id: "IR", label: "Iran", FlagIcon: IR, dialCode: "+98" },
  { id: "IS", label: "Iceland", FlagIcon: IS, dialCode: "+354" },
  { id: "IT", label: "Italy", FlagIcon: IT, dialCode: "+39" },
  { id: "JM", label: "Jamaica", FlagIcon: JM, dialCode: "+1" },
  { id: "JP", label: "Japan", FlagIcon: JP, dialCode: "+81" },
  { id: "KE", label: "Kenya", FlagIcon: KE, dialCode: "+254" },
  { id: "KG", label: "Kyrgyzstan", FlagIcon: KG, dialCode: "+996" },
  { id: "KP", label: "North Korea", FlagIcon: KP, dialCode: "+850" },
  { id: "KR", label: "South Korea", FlagIcon: KR, dialCode: "+82" },
  { id: "KZ", label: "Kazakhstan", FlagIcon: KZ, dialCode: "+7" },
  { id: "LB", label: "Lebanon", FlagIcon: LB, dialCode: "+961" },
  { id: "LI", label: "Liechtenstein", FlagIcon: LI, dialCode: "+423" },
  { id: "LT", label: "Lithuania", FlagIcon: LT, dialCode: "+370" },
  { id: "LU", label: "Luxembourg", FlagIcon: LU, dialCode: "+352" },
  { id: "LV", label: "Latvia", FlagIcon: LV, dialCode: "+371" },
  { id: "MA", label: "Morocco", FlagIcon: MA, dialCode: "+212" },
  { id: "MD", label: "Moldova", FlagIcon: MD, dialCode: "+373" },
  { id: "MK", label: "North Macedonia", FlagIcon: MK, dialCode: "+389" },
  { id: "MN", label: "Mongolia", FlagIcon: MN, dialCode: "+976" },
  { id: "MO", label: "Macau", FlagIcon: MO, dialCode: "+853" },
  { id: "MX", label: "Mexico", FlagIcon: MX, dialCode: "+52" },
  { id: "MY", label: "Malaysia", FlagIcon: MY, dialCode: "+60" },
  { id: "NL", label: "Netherlands", FlagIcon: NL, dialCode: "+31" },
  { id: "NO", label: "Norway", FlagIcon: NO, dialCode: "+47" },
  { id: "NP", label: "Nepal", FlagIcon: NP, dialCode: "+977" },
  { id: "NZ", label: "New Zealand", FlagIcon: NZ, dialCode: "+64" },
  { id: "OM", label: "Oman", FlagIcon: OM, dialCode: "+968" },
  { id: "PH", label: "Philippines", FlagIcon: PH, dialCode: "+63" },
  { id: "PL", label: "Poland", FlagIcon: PL, dialCode: "+48" },
  { id: "PR", label: "Puerto Rico", FlagIcon: PR, dialCode: "+1" },
  { id: "PT", label: "Portugal", FlagIcon: PT, dialCode: "+351" },
  { id: "QA", label: "Qatar", FlagIcon: QA, dialCode: "+974" },
  { id: "RO", label: "Romania", FlagIcon: RO, dialCode: "+40" },
  { id: "RS", label: "Serbia", FlagIcon: RS, dialCode: "+381" },
  { id: "RU", label: "Russia", FlagIcon: RU, dialCode: "+7" },
  { id: "SE", label: "Sweden", FlagIcon: SE, dialCode: "+46" },
  { id: "SG", label: "Singapore", FlagIcon: SG, dialCode: "+65" },
  { id: "SI", label: "Slovenia", FlagIcon: SI, dialCode: "+386" },
  { id: "SK", label: "Slovakia", FlagIcon: SK, dialCode: "+421" },
  { id: "TH", label: "Thailand", FlagIcon: TH, dialCode: "+66" },
  { id: "TM", label: "Turkmenistan", FlagIcon: TM, dialCode: "+993" },
  { id: "TN", label: "Tunisia", FlagIcon: TN, dialCode: "+216" },
  { id: "TR", label: "Turkey", FlagIcon: TR, dialCode: "+90" },
  { id: "TW", label: "Chinese Taipei (Taiwan)", FlagIcon: TW, dialCode: "+886" },
  { id: "UA", label: "Ukraine", FlagIcon: UA, dialCode: "+380" },
  { id: "UZ", label: "Uzbekistan", FlagIcon: UZ, dialCode: "+998" },
  { id: "ZA", label: "South Africa", FlagIcon: ZA, dialCode: "+27" },
];

export const getCountryById = (countryId) =>
  COUNTRY_OPTIONS.find((c) => c.id === countryId) ?? COUNTRY_OPTIONS[0];

export const parseStoredPhone = (phone) => {
  if (!phone || !phone.startsWith("+")) {
    return { countryId: COUNTRY_OPTIONS[0].id, nationalDigits: "" };
  }
  try {
    const number = phoneUtil.parse(phone, "US");
    const region = phoneUtil.getRegionCodeForNumber(number);
    const countryId = region && getCountryById(region).id ? region : COUNTRY_OPTIONS[0].id;
    const nationalDigits = number.getNationalNumber() ? String(number.getNationalNumber()) : "";
    return { countryId, nationalDigits };
  } catch (_) {
    return { countryId: COUNTRY_OPTIONS[0].id, nationalDigits: phone.replace(/\D/g, "") };
  }
};

export const toE164Phone = (countryId, nationalDigits) => {
  if (!nationalDigits) return "";
  try {
    const number = phoneUtil.parse(nationalDigits, countryId);
    return phoneUtil.isValidNumber(number)
      ? phoneUtil.format(number, PhoneNumberFormat.E164)
      : "";
  } catch (_) {
    return "";
  }
};

export const validatePhone = (countryId, nationalDigits) => {
  if (!nationalDigits) return false;
  try {
    const number = phoneUtil.parse(nationalDigits, countryId);
    return phoneUtil.isValidNumber(number);
  } catch (_) {
    return false;
  }
};

export const isValidE164Phone = (e164) => {
  if (!e164) return false;
  try {
    const number = phoneUtil.parse(e164, "US");
    return phoneUtil.isValidNumber(number);
  } catch (_) {
    return false;
  }
};
